var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_vm.newsList.length ? [_c('ul', {
    staticClass: "s-pb-3"
  }, _vm._l(_vm.newsList, function (news, i) {
    return _c('li', {
      key: i,
      staticClass: "s-p-3 pb-0"
    }, [_c('Item', {
      attrs: {
        "news": news
      }
    })], 1);
  }), 0), _c('Pagination', {
    attrs: {
      "current": _vm.page,
      "last": _vm.lastPage
    }
  })] : _c('div', {
    staticClass: "s-pt-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("沒有最新消息")])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }